export default __webpack_public_path__ + "assets/1f0ad344e8fdb4b88d9bb19c3c6f1ca2.png";